import React, { useEffect, useState } from "react";
import classes from "./Payouts.module.scss";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import PaymentGraph from "../../../components/PaymentGraph/PaymentGraph";
import DataTableComponent from "../../../components/DataTableComponent/DataTableComponent";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import DateRangeIcon from "@mui/icons-material/DateRange";
import DownloadIcon from "@mui/icons-material/Download";

import { IIntroducerPayout } from "../../../Utils/dtos";
import {
  DownloadPayoutDetailsAPICall,
  getdashBoardRevenueGraphDataAPICall,
} from "../../../Utils/APICalls";
import { numberWithCommas } from "../../../Utils/CommonFunctions";
import { Helmet } from "react-helmet";
import { Button } from "@mui/material";
import SnackBar from "../../../Components copy/SnackBars/SnackBar";
import SucessSnackBar from "../../../components/SnackBar/SuccessSnackBar";

const titletextStyle = {
  fontSize: "13px",
  fontWeight: 600,
  color: "rgba(34, 34, 34, 1)",
  cursor: "pointer",
};
const divStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const contenttextStyle = { fontSize: "12px", fontWeight: 600 };

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const convertDateFormat = (inputDate: any) => {
  const parts = inputDate.split("-");
  if (parts.length === 3) {
    const [year, month, day] = parts;
    return `${day}-${month}-${year}`;
  } else {
    // Handle invalid date format
    return inputDate;
  }
};

export default function Payouts() {
  const [loading, setloading] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [displayYearandMonth, setDisplayYearandMonth] = useState("");
  const [presentDate, setPresentDate] = useState(new Date().getDate());
  const userDetails: any = sessionStorage.getItem("userDetails");
  const UserDetails: any = JSON.parse(userDetails);
  const [year, setYear] = useState<number>(new Date().getFullYear());
  const [currentYear, setCurrentYear] = useState(new Date());
  const [revenueGraphData, setRevenueGraphData] = useState([]);
  const [graphloading, setgraphloading] = useState(false);
  const [paymentTotal, setpaymentTotal] = useState<number>(0);
  const [payoutFiltredData, setpayoutFiltredData] = useState([]);
  const [paginationCount, setpaginationCount] = useState(1);
  const [downloadMessage, setDownloadMessage] = useState("");
  const [downloadErrorMessage, setDownloadErrorMessage] = useState("");

  useEffect(() => {
    const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
      currentDate
    );
    const year = currentDate.getFullYear();

    const formattedDate = `${month} ${year}`;
    setDisplayYearandMonth(month);
  }, [currentDate]);

  useEffect(() => {
    const year = currentYear.getFullYear();
    setYear(year);
  }, [currentYear]);

  useEffect(() => {
    getDashBoardRevenueGraphData();
  }, [year]);

  const getDashBoardRevenueGraphData = () => {
    setgraphloading(true);
    setloading(true);
    let obj: any = {
      year: year,
    };
    getdashBoardRevenueGraphDataAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data.data);
        setgraphloading(false);
        setloading(false);
        if (response.data.data) {
          const newData = response.data.data.map((item: any) => ({
            ...item,
            Revenue: item.Revenue === 0 ? null : item.Revenue,
            month: monthNames[item.Month - 1], // Adjusted to start from 0 index
          }));
          const latest = response.data.data.every((a: any) => a.Revenue === 0);

          const totalAmount = response.data.data.reduce(
            (sum: any, item: any) => sum + item.Revenue,
            0
          );

          const filtredData = response.data.data.filter(
            (a: any) => a.Revenue !== 0
          );

          const sortedFiltredData = filtredData.sort(
            (a: any, b: any) => a.Month - b.Month
          );
          setpayoutFiltredData(sortedFiltredData);
          setpaymentTotal(totalAmount);

          // console.log("filtredData", filtredData);
          const sortedData = newData.sort(
            (a: any, b: any) => a.Month - b.Month
          );

          setRevenueGraphData(!latest ? sortedData : []);
        }
      })
      .catch((error: any) => {
        setgraphloading(false);
        setloading(false);
        // console.log("error", error);
      });
  };

  const columns = [
    {
      name: (
        <b style={titletextStyle}>
          {" "}
          <div style={divStyles}>
            <DateRangeIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>Date</p>
          </div>
        </b>
      ),
      selector: "TranDate",
      cell: (row: any) => (
        <b style={contenttextStyle}>{convertDateFormat(row.TranDate)}</b>
      ),
    },
    {
      name: (
        <b style={titletextStyle}>
          {" "}
          <div style={divStyles}>
            <PaymentsOutlinedIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>Revenue</p>
          </div>
        </b>
      ),
      selector: "Revenue",

      cell: (row: any) => (
        <b style={contenttextStyle}>₹{numberWithCommas(row.Revenue)}</b>
      ),
    },
    {
      name: (
        <b style={titletextStyle}>
          {" "}
          <div style={divStyles}>
            <ArticleOutlinedIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>GST</p>
          </div>
        </b>
      ),
      selector: "GST",

      cell: (row: any) => (
        <b style={contenttextStyle}>{row.GST === 0 ? "-" : row.GST}</b>
      ),
    },

    {
      name: (
        <b style={titletextStyle}>
          {" "}
          <div style={divStyles}>
            <ReceiptOutlinedIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>TDS</p>
          </div>
        </b>
      ),
      selector: "TDS",
      // sortable: true,
      // width: "200px",
      cell: (row: any) => (
        <b style={contenttextStyle}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // width: "130px",
            }}
          >
            <p>₹{numberWithCommas(row.TDS)}</p>
          </div>
        </b>
      ),
    },
    {
      name: (
        <b style={titletextStyle}>
          {" "}
          <div style={divStyles}>
            <AccountBalanceWalletIcon
              style={{ color: "rgba(34, 34, 34, 1)", marginRight: "5px" }}
            />{" "}
            <p>Net Pay</p>
          </div>
        </b>
      ),
      selector: "NetPay",

      cell: (row: any) => (
        <b style={contenttextStyle}>₹{numberWithCommas(row.NetPay)}</b>
      ),
    },
  ];

  const handlePreviousMonthClick = () => {
    const previousMonth = new Date(currentDate);
    previousMonth.setMonth(previousMonth.getMonth() - 1);
    setCurrentDate(previousMonth);
  };

  const handleNextMonthClick = () => {
    const previousMonth = new Date(currentDate);
    previousMonth.setMonth(previousMonth.getMonth() + 1);
    setCurrentDate(previousMonth);
  };
  const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
    currentDate
  );
  const newmonth = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
    new Date()
  );
  const presentYear = currentDate.getFullYear();

  const handlePreviousYearClick = () => {
    setYear((previous: any) => previous - 1);
  };
  const handleNextYearClick = () => {
    setYear((previous: any) => previous + 1);
  };

  const handlePageChange = (event: any, page: any) => {};

  const handleDownloadPayout = () => {
    let obj: any = {
      year: year,
    };

    DownloadPayoutDetailsAPICall(obj)
      .then((response: any) => {
        downloadCsv(response.data);
        setDownloadMessage("Reports Download successfully");
        setTimeout(() => {
          setDownloadMessage("");
        }, 5000);
      })
      .catch((error: any) => {
        if (error.response.data.error.message) {
          setDownloadErrorMessage(error.response.data.error.message);
        } else {
          setDownloadErrorMessage("Error downloading");
        }
        setTimeout(() => {
          setDownloadErrorMessage("");
        }, 5000);
      });
  };

  const downloadCsv = (csvContent) => {
    const blob = new Blob([csvContent], { type: "csv" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Payout ${year}.csv`);
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      <Helmet>
        <title>Payouts</title>
        <meta name="Payouts" content="Payouts" />
      </Helmet>
      <SnackBar message={downloadErrorMessage} />
      <SucessSnackBar message={downloadMessage} />
      <div className={classes.mainWrapper}>
        <div className={classes.leftContainerTopTitle}>
          {/* <p className={classes.welcomeText}>
          Welcome {UserDetails ? UserDetails.Name : ""}
        </p> */}
          <p className={classes.dashboardText}>Payment Details</p>
          {/* <div className={classes.nextTopPreviousSection}>
          <div
            className={classes.topprevious}
            onClick={handlePreviousMonthClick}
          >
            <KeyboardArrowLeftIcon />
          </div>
          <div className={classes.topyearText}>{displayYearandMonth}</div>
          <div
            className={classes.topnext}
            onClick={() => {
              if (month !== newmonth) {
                handleNextMonthClick();
              }
            }}
            style={{ background: month === newmonth ? "grey" : "" }}
          >
            <KeyboardArrowRightIcon />
          </div>
        </div> */}
          <div
            className={classes.buttonSection}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div className={classes.nextPreviousSection}>
              <div
                className={classes.previous}
                onClick={handlePreviousYearClick}
              >
                <KeyboardArrowLeftIcon />
              </div>
              <div className={classes.yearText}>{year}</div>
              <div
                className={classes.next}
                onClick={() => {
                  if (presentYear !== year) {
                    handleNextYearClick();
                  }
                }}
                style={{ background: presentYear === year ? "grey" : "" }}
              >
                <KeyboardArrowRightIcon />
              </div>
            </div>
            <div>
              <Button
                variant="contained"
                sx={{
                  textTransform: "none",
                  fontSize: "13px",
                  "&:hover": {
                    background: "rgba(0, 103, 121, 1)",
                  },
                }}
                startIcon={<DownloadIcon />}
                onClick={handleDownloadPayout}
              >
                Download reports
              </Button>
            </div>
          </div>
        </div>

        <div className={classes.paymentStatics}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>
              <p className={classes.paymentStaticsText}>Payment Statistics</p>
              <p className={classes.paymentStaticsAmount}>
                ₹
                {Math.floor(
                  parseFloat(paymentTotal.toString())
                ).toLocaleString()}
              </p>
            </div>
            {/* <div className={classes.buttonSection}>
            <div className={classes.nextPreviousSection}>
              <div
                className={classes.previous}
                onClick={handlePreviousYearClick}
              >
                <KeyboardArrowLeftIcon />
              </div>
              <div className={classes.yearText}>{year}</div>
              <div
                className={classes.next}
                onClick={() => {
                  if (presentYear !== year) {
                    handleNextYearClick();
                  }
                }}
                style={{ background: presentYear === year ? "grey" : "" }}
              >
                <KeyboardArrowRightIcon />
              </div>
            </div>
          </div> */}
          </div>
          <div className={classes.paymentStaticsGraph}>
            <PaymentGraph
              revenueGraphData={revenueGraphData}
              loading={graphloading}
            />
          </div>
        </div>

        <div
          className={classes.tableWrapper}
          style={{ border: loading ? " " : "1px solid rgba(213, 233, 236, 1)" }}
        >
          <DataTableComponent
            data={payoutFiltredData}
            columns={columns}
            loading={loading}
            paginationCount={paginationCount}
            handlePageChange={handlePageChange}
            payout={true}
          />
        </div>
      </div>
    </>
  );
}
